import { Component } from '@angular/core';

@Component({
    selector: 'yeti-modal',
    template: `
    <ng-content></ng-content>
    `
})

export class YetiModalComponent {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/yeti-modal/yeti-modal.component.ts